import { App } from "@/App.js";
import "./styles/style.scss";
import { createElement } from "@/utils/create-elem.js";

const root = createElement({
  tag: "div",
  id: "app",
});
document.querySelector("body").prepend(root);
App(root);
